    <template>
    <div id="adminlogin">
        <div class="container-fluid">
            <Alert v-bind:message='error'   type="alert-danger" v-if="error"/>
            <div class="row">
                    <div class="col-12 text-center my-5 ">
                        <img height="50" src="../assets/tribeid.png" alt="">
                    </div>
                </div>

            <div class="row justify-content-center align-items-">
                
                <div class="col-lg-5 col-md-8 col-sm-11">
                    <div class="card">
                        <div class="card-header">
                            <h2 class="text-center">Admin Login</h2>
                        </div>
                        <div class="card-body">
                            <form class="" @submit.prevent="login">
                            <div class="form-group mb-2">
                                <label for="staticEmail2" class="form-label">Email</label>
                                <input type="email" class="form-control" id="staticEmail2" required placeholder="me@example.com" v-model.trim="email">
                            </div>
                            <div class="form-group mb-2">
                                <label for="inputPassword2" class="form-label">Password</label>
                                <input type="password" class="form-control" id="inputPassword2" required placeholder="Password" v-model.trim="password">
                            </div>
                            <button type="submit" class="btn btn-outline-danger my-2 btn-lg">
                                login  
                                  <RoundSpinner v-if="loading" />
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alert from '../components/Alert'
import url from '../url.js'
import RoundSpinner from '../components/RoundSpinner'
import Roles from '@/api/roles'
import formartrole from '@/helpers/formatroles.js'
export default {
    components: {
        Alert:Alert,
        RoundSpinner:RoundSpinner
    },
    data(){
        return {
            email:'',
            password:'',
            error:'',
            loading:false,
        }
    },
    methods: {
        login() {
            this.loading = true
            this.error = ''
            const data = {
                email:this.email,
                password:this.password
            }
            this.$store.dispatch('adminLogin',data)
                .then( (response) => {  
                    this.loading = false
                    const data = response.data;
                    const role = Roles.find( role => role.key === formartrole(response.data.role.toLowerCase()))
                    this.$store.dispatch('setDashboard',role.dashboard)
                    this.$store.dispatch('setCurrentUser',data)
                    this.$router.push(`/admin`)
                    })
                .catch( (err) => {
                    if(err?.response?.data === undefined) {
                        this.loading = false;
                        this.error = 'Network error!.Try again.'
                    }
                })
           }

    },

}
</script>

<style scoped>
    #adminlogin{
        background-image:url('../assets/hero.jpg');
        width:100%;
        background-position: center;
        background-attachment: fixed;
        background-repeat: no-repeat;
        height: 100vh;
    }
    h2{
        color:black;
        font-weight: 500;
    }
    button{
        width:100%;
    }
</style>    